import axios from "../utils/axios";
import {requests} from "../utils/urls";

const getAllGeofence = async () => {
    try {
        return await axios.get(requests.management.geofence.getAll);
    } catch (e) {
        return e.response;
    }
};

const changeGeofenceActiveState = async (geofenceId, values) => {
    try {
        return await axios.patch(requests.management.geofence.isActive(geofenceId), values);
    } catch (e) {
        return e.response;
    }
};

const deleteGeofence = async (geofenceId) => {
    try {
        return await axios.delete(requests.management.geofence.delete(geofenceId))
    } catch (e) {
        return e.response;
    }
};

const addGeofence = async (values) => {
    try {
        return await axios.post(requests.management.geofence.create, values);

    } catch (e) {
        return e.response;
    }
};

const editGeofence = async (geofenceId, values) => {
    try {
        return await axios.patch(requests.management.geofence.edit(geofenceId), values);
    } catch (e) {
        return e.response;
    }
};

const getGeofenceById = async (geofenceId) => {
    try {
        return await axios.get(requests.management.geofence.getById(geofenceId));
    } catch (e) {
        return e.response;
    }
};


export {
    getAllGeofence,
    changeGeofenceActiveState,
    deleteGeofence,
    addGeofence,
    editGeofence,
    getGeofenceById
}